<template>
    <Component
        :is="componentInstance"
        v-bind="$attrs"
        :get-data-vuex="getCRM"
        :placeholder="placeholder"
        :multiple="multiple"
        :value="value"
        class="white"
        field="name"
        prop="alias"
        @[event]="$emit(event, $event)">
    </Component>
</template>
<script>
  import IntegrationCRMOutput from "@/components/Common/Output/IntegrationCRMOutput.vue";
  import UserOutput from "@/components/Common/Output/UserOutput.vue";
  import { UsersSelect } from "@core/mixins/select/usersSelect";

  export default {
    name: "CRMSelect",
    mixins: [UsersSelect],

    components: { IntegrationCRMOutput, UserOutput },

    props: {
      routeParam: {
        type: String,
        default: "crm"
      },

      namespaceModule: {
        type: String,
        default: "CRMFilters"
      }
    },

    methods: {
      async getCRM (label = "", isLoading = false) {
        await this.getFiltersCommon(
          this.namespaceModule, this.list, this.$route.query[this.routeParam] ?? this.value,
          this.routeParam, "name", label, isLoading, this.filterOptions
        );
        return this.list;
      }
    }
  };
</script>

<style scoped>
</style>